export default class AbstractStorage {
}
